module.exports = __webpack_public_path__ + "img/anger_with_flames.2abb99e2.jpg";